import { RouteObject } from 'react-router';

const agbRoutes: RouteObject[] = [
  {
    path: 'agb',
    lazy: () => import('./page/agb-page.tsx'),
  },
];

export default agbRoutes;
